import React from 'react';
import PropTypes from 'prop-types';

import Definition from '../../../shared/Definition';

/**
 * @param studFee array|null
 * @param weatherbysUid string|null
 * @returns {*}
 * @constructor
 */
const Standing = ({ studFee, weatherbysUid }) => {
    if (studFee && studFee.length) {
        const {
            studName,
            countryCode,
            nominationFee,
        } = studFee[0];

        if (weatherbysUid) {
            return (
                <Definition term="" forceShow perfectCenter>
                    <span className="weatherbys-standing__wrapper">
                        Standing at {studName} ({countryCode}) {nominationFee !== 0 ? 'for' : ''}
                    </span>
                </Definition>
            );
        }

        return (
            <Definition term="Standing">
                <span>{studName} ({countryCode})</span>
            </Definition>
        );
    }
    return null;
};

Standing.propTypes = {
    weatherbysUid: PropTypes.string,
    studFee: PropTypes.arrayOf(PropTypes.shape({
        countryCode: PropTypes.string,
        studName: PropTypes.string,
    })),
};

export default Standing;



// WEBPACK FOOTER //
// ./src/js/horse/details/components/Standing.jsx